import { render, staticRenderFns } from "./CodeTypeDialog.vue?vue&type=template&id=96e4306a&scoped=true&"
import script from "./CodeTypeDialog.vue?vue&type=script&lang=js&"
export * from "./CodeTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e4306a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96e4306a')) {
      api.createRecord('96e4306a', component.options)
    } else {
      api.reload('96e4306a', component.options)
    }
    module.hot.accept("./CodeTypeDialog.vue?vue&type=template&id=96e4306a&scoped=true&", function () {
      api.rerender('96e4306a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createFlow/build/CodeTypeDialog.vue"
export default component.exports